import style from "./access-toast.module.css";

export default function AccessToast({ text, customStyle }: { text: string; customStyle?: React.CSSProperties }) {
  return (
    <div className={style.container} style={customStyle}>
      <div className={style.content}>
        <span className={style.toastText}>{text}</span>
      </div>
    </div>
  );
}
